import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { get, useFormState } from "react-hook-form";
//#region src/TextArea/TextAreaErrorContainer.tsx
const TextAreaErrorContainer = React.memo(({ textareaRef, control, name }) => {
	const formState = useFormState({
		control,
		name
	});
	const error = get(formState.errors, `${name}.message`);
	React.useEffect(() => {
		if (!textareaRef.current) return;
		if (error) {
			textareaRef.current.classList.add("textarea-error");
			return;
		}
		textareaRef.current.classList.remove("textarea-error");
	}, [error, textareaRef]);
	if (!error) return null;
	return /* @__PURE__ */ jsx("p", {
		"data-cy": "textArea-p",
		className: cn("text-system-error-50 mt-[.125rem]"),
		children: error
	});
});
TextAreaErrorContainer.displayName = "TextAreaErrorContainer";
//#endregion
export { TextAreaErrorContainer };

//# sourceMappingURL=TextAreaErrorContainer.js.map